import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserDetails } from '../stores/slices/user/userActions';
import { logout } from '../stores/slices/user/userSlice';

const useUserAuth = () => {
  const { userToken, error } = useSelector(state => state.user);
  const dispatch = useDispatch();

  // automatically authenticate user if token is found
  useEffect(() => {
    if (userToken) {
      dispatch(getUserDetails());
    }else{
      dispatch(logout());
    }
  }, [userToken, dispatch]);

  if (error && error.status === 401) {
    dispatch(logout());
    return false;
  }

  if (error) return error;
};

export default useUserAuth;
